function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, forwardRef } from "react";
import { Table, Tag, Row, Col, Image, Alert } from "antd";
import Moment from "react-moment";
import { Container } from "react-bootstrap";
import Common from "./includes/Common";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Invoice = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref2, _ref3, _ref4;
  var invoice = _ref.invoice;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    itemsAr = _useState2[0],
    setItemsAr = _useState2[1];
  var cols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "D\xE9signation"
    }),
    dataIndex: "label",
    key: "label",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, (_ref2 = {
    title: /*#__PURE__*/_jsx("b", {
      children: "P.Unitaire"
    }),
    dataIndex: "price"
  }, _defineProperty(_ref2, "dataIndex", "price"), _defineProperty(_ref2, "render", function render(price) {
    return /*#__PURE__*/_jsx("span", {
      children: price.toLocaleString("Fr")
    });
  }), _ref2), (_ref3 = {
    title: /*#__PURE__*/_jsx("b", {
      children: "Qte"
    }),
    dataIndex: "quantity"
  }, _defineProperty(_ref3, "dataIndex", "quantity"), _defineProperty(_ref3, "render", function render(qte) {
    return /*#__PURE__*/_jsx("span", {
      children: qte.toLocaleString("Fr")
    });
  }), _ref3), (_ref4 = {
    title: /*#__PURE__*/_jsx("b", {
      children: "Total"
    }),
    dataIndex: "s_total"
  }, _defineProperty(_ref4, "dataIndex", "s_total"), _defineProperty(_ref4, "render", function render(t) {
    return /*#__PURE__*/_jsx("span", {
      children: t.toLocaleString("Fr")
    });
  }), _ref4)];
  useEffect(function () {
    invoice.bill_items.forEach(function (item) {
      setItemsAr(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          key: item.id,
          label: item.label,
          price: item.price,
          quantity: item.quantity,
          s_total: item.price * item.quantity
        }]);
      });
    });
  }, []);
  return /*#__PURE__*/_jsxs(Container, {
    ref: ref,
    id: "printable",
    children: [/*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx(Col, {
        span: 6,
        children: /*#__PURE__*/_jsx(Image, {
          preview: false,
          src: Common.businessAccount.logo,
          width: "100%"
        })
      }), /*#__PURE__*/_jsx(Col, {
        span: 16,
        offset: 2,
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            textAlign: "center"
          },
          children: [/*#__PURE__*/_jsx("h2", {
            children: /*#__PURE__*/_jsx("b", {
              children: Common.businessAccount.business_label
            })
          }), /*#__PURE__*/_jsx("div", {
            style: {
              color: "#C00000"
            },
            children: /*#__PURE__*/_jsx("b", {
              children: Common.businessAccount.address
            })
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsxs("b", {
              children: [" ", Common.businessAccount.mobile, " ; Email : ", Common.businessAccount.email]
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      style: {
        border: "4px solid #FBB03C"
      }
    }), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Col, {
        span: 7,
        offset: 17,
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            marginTop: "10px",
            fontSize: "20px"
          },
          children: ["Le ", /*#__PURE__*/_jsx(Moment, {
            date: invoice.created_at,
            format: "DD/MM/YYYY"
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
        })
      })
    }), /*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx(Col, {
        span: 7,
        children: /*#__PURE__*/_jsxs("h3", {
          children: [/*#__PURE__*/_jsx("b", {
            children: "FACTURE N\xB0: "
          }), " ", invoice.id]
        })
      }), /*#__PURE__*/_jsx(Col, {
        span: 15,
        offset: 2,
        children: /*#__PURE__*/_jsx("div", {
          style: {
            padding: "10px",
            background: "#666666"
          },
          children: /*#__PURE__*/_jsx("h3", {
            style: {
              textAlign: "center"
            },
            children: /*#__PURE__*/_jsx("b", {
              style: {
                color: "#FFF"
              },
              children: invoice.company.label
            })
          })
        })
      })]
    }), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsxs(Col, {
        span: 24,
        children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Table, {
          dataSource: itemsAr,
          columns: cols,
          pagination: false,
          bordered: true
        })]
      })
    }), /*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsxs(Col, {
        span: 17,
        children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h4", {
          children: [/*#__PURE__*/_jsx("b", {
            children: "TOTAL : "
          }), " ", invoice.total_amount.toLocaleString("Fr"), " GNF"]
        })]
      }), /*#__PURE__*/_jsx(Col, {
        span: 7
      })]
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Col, {
        span: 24,
        children: /*#__PURE__*/_jsx(Alert, {
          type: "info",
          showIcon: true,
          banner: true,
          message: /*#__PURE__*/_jsx("span", {
            children: invoice.comment
          })
        })
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
      style: {
        border: "1px solid #9C9898",
        padding: "7px"
      },
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          border: "4px solid #5B9BD5"
        }
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          span: 10,
          children: Common.businessAccount.business_label
        }), /*#__PURE__*/_jsx(Col, {
          span: 10,
          offset: 4,
          children: /*#__PURE__*/_jsx("b", {
            children: Common.businessAccount.address
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        style: {
          border: "4px solid #5B9BD5"
        }
      })]
    })]
  });
});
export default Invoice;